// extracted by mini-css-extract-plugin
export var group = "styles-module--group--12518";
export var groups = "styles-module--groups--8ed17";
export var header = "styles-module--header--0728e";
export var range = "styles-module--range--58027";
export var script = "styles-module--script--7554b";
export var square = "styles-module--square--9a88b";
export var subtext = "styles-module--subtext--b0336";
export var wrapper = "styles-module--wrapper--6b4de";